import { v } from 'convex/values';

/**
 * Stable tag keys for the in-app feedback chips. Locale-independent on purpose:
 * only the labels are translated, so analytics survive wording changes.
 */
export const FEEDBACK_TAGS_LOW = [
  'slow',
  'bug',
  'missing-feature',
  'too-complex',
  'price',
] as const;

export const FEEDBACK_TAGS_HIGH = [
  'qr-bills',
  'payroll',
  'simplicity',
  'support',
  'price',
] as const;

export const FEEDBACK_TAGS: readonly string[] = [
  ...FEEDBACK_TAGS_LOW,
  ...FEEDBACK_TAGS_HIGH,
];

export const feedbackValidator = {
  userId: v.id('users'),
  rating: v.number(), // 1..5
  comment: v.optional(v.string()),
  tags: v.optional(v.array(v.string())), // subset of FEEDBACK_TAGS
  locale: v.optional(v.string()),
  createdAt: v.number(),
};
